import React from "react";
import { pluralize } from "@common/helpers/string";
import { useFinancialAccounts } from "@hooks/useFinancialAccounts";
import { BreakableText } from "@design-system/BreakableText/BreakableText";

interface Props {
    filters: {
        subaccountIds?: string[];
    };
}

export const SubaccountsFilterLabel: React.FC<Props> = ({
    filters: { subaccountIds },
}) => {
    const accounts = useFinancialAccounts();

    if (subaccountIds?.length === 1) {
        const selectedSubaccount = accounts
            .flatMap(({ subaccounts }) => subaccounts)
            .find(
                (subaccount) =>
                    subaccount && subaccount.id === subaccountIds[0],
            );

        return (
            <BreakableText text={selectedSubaccount?.name ?? "Subaccount"} />
        );
    }

    return (
        <>
            {subaccountIds?.length}{" "}
            {pluralize("Subaccount", subaccountIds?.length ?? 0)}
        </>
    );
};
